import { SCHEDULING_AVAILABILITY } from '../../constants'

export default () => ({
  ...initialState(),
})

export const initialState = () => ({
  pcpsOnFile: undefined,
  healthPlanRequiresPersonalDoctor: false, // TODO - we don't know where this will come from
  selectedDoctors: [],
  doctorPreferences: {
    distance: undefined,
    gender: undefined,
  },
  recommendedDoctors: [],
  selectedAvailability: initialAvailailityFactory(),
  zipCode: '',
  isFetchingProviders: false,
  isFetchingPcpsOnFile: false,
  scheduledAppointment: undefined,
  isFetchingScheduledAppointment: false,
})

export function initialAvailailityFactory() {
  return {
    [SCHEDULING_AVAILABILITY.DAYS.MONDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.TUESDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.WEDNESDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.THURSDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.FRIDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.SATURDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
    [SCHEDULING_AVAILABILITY.DAYS.SUNDAY]: {
      [SCHEDULING_AVAILABILITY.TIMES.MORNING]: false,
      [SCHEDULING_AVAILABILITY.TIMES.MIDDAY]: false,
      [SCHEDULING_AVAILABILITY.TIMES.AFTERNOON]: false,
    },
  }
}

export const APPOINTMENT_STATUS = Object.freeze({
  QUEUED: 'queued',
  IN_PROGRESS: 'in_progress',
  TRIGGERED: 'triggered',
  SUCCESS: 'success',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
})
